import { BaseEntity } from 'yt-ng-framework';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
export class DokumentView extends BaseEntity{
    constructor(){
        super();
    }

    Vrsta: string = null;
    Datum: NgbDate = null;
    IznosPoKursuTrans=null;
    IznosPoSrednjemKursu=null;
    KursnaRazlika=null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Vrsta = input.Vrsta;
        this.Datum = input.Datum;
        this.IznosPoKursuTrans=input.IznosPoKursuTrans;
        this.IznosPoSrednjemKursu=input.IznosPoSrednjemKursu;
        this.KursnaRazlika=input.KursnaRazlika;
        let date = new Date();
        //this.Editable = new Date(this.Datum.year, this.Datum.month -1, this.Datum.day) >= new Date(date.getFullYear(), date.getMonth(), date.getDate());
        //this.Deletable = new Date(this.Datum.year, this.Datum.month - 1, this.Datum.day) >= new Date(date.getFullYear(), date.getMonth(), date.getDate());

        return this;
    }

    Serialize(input: DokumentView){
        input.Vrsta="U";
        return input;
    }

    GetInstance(){
        return this;
    }
}   